import {SupportedLocales} from '@gl/types/locale.js';

export const queueEventsLang = {
  [SupportedLocales.EN]: {
    queueEventForm: {
      eventNameLabel: 'Event Name',
      eventNamePlaceholder: 'Enter an event name',
      eventPathLabel: 'Path to Event',
      eventPathPlaceholder: 'Enter a path to the event',
      eventPathTooltip:
        'Please provide the path to your event_type (in a dotted notation such as "properties.event_type") on the JSON event provided below.',
      eventSchemaLabel: 'Register Event Schema',
      eventValueLabel: 'Event Value',
      eventValueTooltip:
        "Please provide the expected value of the event_type you'd like to register (eg, 'purchase').",
      eventValuePlaceholder: 'Enter an event value',
      exampleLinkText: 'Download example',
      resetButton: 'Cancel',
      sourceConnectionLabel: 'Event Source',
      sourceConnectionPlaceholder: 'Select an event source',
      submitButton: 'Save',
    },
    datasetGroupQueueEventDatasetsTable: {
      noMatches: {
        headline: 'There are no dataset group realtime events.',
        caption: "Looks like you haven't added a dataset group realtime event.",
      },
      searchText: 'Search',
    },
    queueEventsTable: {
      noMatches: {
        headline: 'There are no realtime events.',
        caption: "Looks like you haven't added a realtime event.",
      },
      createButton: 'Create a realtime event',
      searchText: 'Search',
    },
    queueEventMappingForm: {
      addFieldButton: 'Add mapping',
      cancelButton: 'Cancel',
      datasetFieldLabel: 'Dataset Field',
      datasetFieldPlaceholder: 'Select dataset field',
      fetchError:
        'Error fetching mapping fields. Please refresh the page and try again.',
      legend: 'Map Configuration',
      realtimeEventFieldLabel: 'Realtime Event',
      realtimeEventFieldPlaceholder: 'Select realtime event',
      realtimeEventPlaceholder: 'Select a realtime event',
      realtimeEventEmptyPlaceholder: 'No valid events to map',
      subtitle: 'Tell us how to map your dataset.',
      title: 'Add Realtime Events',
      updateTitle: 'Update Realtime Events',
      submitButton: 'Save',
    },
    queueEventDeleteModal: {
      title: 'Delete Realtime Event',
      description: 'Are you sure you want to delete this realtime event?',
      cancelButton: 'Cancel',
      confirmButton: 'Confirm',
    },
    datasetGroupQueueEventDeleteModal: {
      title: 'Delete Dataset Group Realtime Event',
      description:
        'Are you sure you want to delete this dataset group realtime event?',
      cancelButton: 'Cancel',
      confirmButton: 'Confirm',
    },
  },
  [SupportedLocales.ES]: {
    queueEventForm: {
      eventNameLabel: 'Nombre del evento',
      eventNamePlaceholder: 'Ingrese el nombre del evento',
      eventPathLabel: 'Ruta al evento',
      eventPathPlaceholder: 'Ingrese una ruta al evento',
      eventPathTooltip:
        'Proporcione la ruta a su event_type (en una notación de puntos como "propiedades.event_type") en el evento JSON proporcionado a continuación.',
      eventSchemaLabel: 'Registrar esquema de eventos',
      eventValueLabel: 'Valor del evento',
      eventValueTooltip:
        'Proporcione el valor esperado del event_type que desea registrar (por ejemplo, "compra").',
      eventValuePlaceholder: 'Ingrese un valor de evento',
      exampleLinkText: 'Descargar ejemplo',
      resetButton: 'Cancelar',
      sourceConnectionLabel: 'Fuente de eventos',
      sourceConnectionPlaceholder: 'Seleccionar una fuente de eventos',
      submitButton: 'Guardar',
    },
    datasetGroupQueueEventDatasetsTable: {
      noMatches: {
        headline:
          'No hay eventos en tiempo real del grupo de conjuntos de datos.',
        caption:
          'Parece que no has agregado un evento en tiempo real del grupo de conjuntos de datos.',
      },
      searchText: 'Buscar',
    },
    queueEventsTable: {
      noMatches: {
        headline: 'No hay eventos en tiempo real.',
        caption: 'Parece que no has agregado un evento en tiempo real.',
      },
      createButton: 'Crear una evento en tiempo real',
      searchText: 'Buscar',
    },
    queueEventMappingForm: {
      addFieldButton: 'Agregar mapeo',
      cancelButton: 'Cancelar',
      datasetFieldLabel: 'Campo del conjunto de datos',
      datasetFieldPlaceholder: 'Seleccionar campo del conjunto de datos',
      fetchError:
        'Error al obtener campos de mapeo. Por favor, actualiza la página e inténtalo de nuevo.',
      legend: 'Configuración de mapeo',
      realtimeEventFieldLabel: 'Evento en tiempo real',
      realtimeEventFieldPlaceholder:
        'Seleccionar campo de evento en tiempo real',
      realtimeEventPlaceholder: 'Seleccionar un evento en tiempo real',
      realtimeEventEmptyPlaceholder: 'No hay eventos válidos para mapear',
      submitButton: 'Guardar',
      subtitle: 'Dinos cómo mapear tu conjunto de datos.',
      title: 'Agregar eventos en tiempo real',
      updateTitle: 'Actualizar eventos en tiempo real',
    },
    queueEventDeleteModal: {
      title: 'Eliminar evento en tiempo real',
      description:
        '¿Estás seguro de que deseas eliminar este evento en tiempo real?',
      cancelButton: 'Cancelar',
      confirmButton: 'Confirmar',
    },
    datasetGroupQueueEventDeleteModal: {
      title: 'Eliminar evento en tiempo real del grupo de conjuntos de datos',
      description:
        '¿Estás seguro de que deseas eliminar este evento en tiempo real del grupo de conjuntos de datos?',
      cancelButton: 'Cancelar',
      confirmButton: 'Confirmar',
    },
  },
};
